import { css } from '@emotion/react'
import {
  Color,
  Theme,
  OppositeTheme,
  Spacing,
  Typography,
  Size,
  ShadowElevation,
  Shadow,
} from '@opallabs/gem'

export const content = (theme: Theme) =>
  css({
    borderRadius: Size.Rounding,
    maxInlineSize: Spacing.XS * 75,
    paddingBlock: Spacing.XS,
    paddingInline: Spacing.S,
    ...Typography.T300,
    backgroundColor: Color[OppositeTheme[theme]].Surface.N000,
    color: Color[theme].Text.InvertedDefault,
    ...Shadow[ShadowElevation.E2],
  })

export const arrow = (theme: Theme) =>
  css({
    fill: Color[OppositeTheme[theme]].Surface.N000,
  })
